import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=3490e314&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=ts&"
export * from "./BrandList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490e314",
  null
  
)

export default component.exports